/* eslint-disable no-new-object */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-alert */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import axios from 'axios';
import VueAxios from 'vue-axios';
import que from '@/service/questions';


const state = {
  toZh: {
    1: {
      name: '實務一',
    },
    2: {
      name: '實務二',
    },
    3: {
      name: '觀光資源概要',
    },
    4: {
      name: '英語',
    },
    5: {
      name: '日語',
    },
    G: {
      name: '導遊',
    },
    L: {
      name: '領隊',
    },
    U: {
      name: '華外語',
    },
    C: {
      name: '華外語',
    },
    J: {
      name: '外語',
    },
    E: {
      name: '外語',
    },
  },
  // msgAnalyze{index是題目id}
  msgAnalyze: {
    1: {
      student: [
        {
          isBest: true,
          level: '1級會員',
          img: 'https://placekitten.com/300/300',
          name: 'foo',
          text: '這題答案為XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
          thumbs_up: 2,
          thumbs_down: 0,
          date: '2020/05/20',

        },
        {
          isBest: false,
          level: '1級會員',
          img: '',
          name: 'foo',
          text: '這題答案為XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
          thumbs_up: 2,
          thumbs_down: 0,
          date: '2020/05/20',
        },
        {
          isBest: false,
          level: '1級會員',
          img: 'https://placekitten.com/300/300',
          name: 'foo',
          text: '這題答案為XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
          thumbs_up: 2,
          thumbs_down: 0,
          date: '2020/05/20',
        },
      ],
      admin: [
        {
          isBest: true,
          level: '管理員',
          img: 'https://placekitten.com/300/300',
          name: 'XXX老師',
          text: '這題答案為XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
          thumbs_up: 2,
          thumbs_down: 0,
          date: '2020/05/20',
        },
      ],
    },
  },
  questions: [],
  selectedAns: {},
  selectedStatus: [],
  selectedStatus2: [],
  selectedValue: [],
  selectedShowDetial: [],
  AnalyzeTypeList: [],
  questionTag: [],
  single: false,
  finish: false,
  stopTimes: false,
  allwaysAns: false,
  qkey: 0,
  score: 0,
  message: '',
  showDetial: false,
  ansStatus2: [],
};

// actions
const actions = {
  getQuestons({
    commit,
  }, data) {
    commit('setQuestions', {});
   
    const paramsData = {
      year: data.year,
      examId: data.examId,
      type: data.type,
      method: data.method,
    };
    const con = que.getQuestions(paramsData);


    con.then((response) => {
      commit('setQuestions', response.data);

    });

    return con;
  },
  check({
    commit,
  }, data) {
    commit('checksingle', data);
  },
  calculationScore({
    state,
    commit,
  }) {
    const finishedQuestions = _.size(state.questions.questionAns);
    const scorePer = 100 / finishedQuestions;
    let score = 0;
    state.questions.questionAns.forEach((element, index) => {
      const correctAns = element.ans.indexOf(state.selectedAns[index]);
      if (correctAns !== -1) {
        score += scorePer;
        commit('setScore', score.toFixed(2));
      } else {
        score += 0;
        commit('setScore', score.toFixed(2));
      }
    });
    // for (let i = 0; i < state.questions.questionAns.length; i += 1) {
    //   const correctAns = state.questions.questionAns[i].ans.indexOf(state.selectedAns[i]);
    //   console.log(correctAns);
    //   if (correctAns !== -1) {
    //     score += scorePer;
    //     commit('setScore', score.toFixed(2));
    //   } else {
    //     score += 0;
    //     commit('setScore', score.toFixed(2));
    //   }
    // }
    // commit('setScore', myscore.toFixed(2));
  },
  checkFinish({
    state,
    commit,
  }) {
    const finishedQuestions = _.size(state.questions.questionAns);

    if (finishedQuestions > _.size(state.selectedAns)) {
      ('沒做完');

      commit('saveFinish', {
        tf: false,
        msg: `尚有 ${state.questions.totalQuestion - _.size(state.selectedAns)} 題未作答，是否交卷？`
      });
      commit('setTimes', false);
    } else {
      commit('saveFinish', {
        tf: false,
        msg: '是否交卷？',
      });
      commit('setTimes', false);
    }
  },
  writeAns({
    commit,
  }, data) {
    commit('setAns', data);
  },
};

// mutations
const mutations = {
  setTag(state, data) {
    state.questionTag[data.index - 1] = data.status;
  },
  setansStatus2(state, data) {
    for (let i = 0; i < state.questions.totalQuestion; i += 1) {
      state.ansStatus2[i] = data;
    }
  },
  setAllwaysAns(state, data) {
    if (data === false) {
      state.questionTag = [];
    }
    state.allwaysAns = data;
  },
  setQuestions(state, data) {
    state.questions = data;
  },
  setTimes(state, data) {
    state.stopTimes = data;
  },
  checksingle(state, data) {
    state.single = data;
  },
  saveFinish(state, data) {

    state.finish = data.tf;
    state.message = data.msg;
  },
  setqkey(state, data) {
    state.qkey = data;
  },
  setAns(state, data) {
    // state.questions[data.myindex].selectq = data.myvalue;
    // state.questions[data.myindex].status = data.mystatus;
    // state.selectedAns[data.myindex - 1] = data.myvalue;
    if (!state.allwaysAns) {
      state.selectedAns[data.myindex - 1] = data.myvalue;
      // state.selectedStatus[data.myindex - 1] = data.mystatus;
      // state.selectedValue[data.myindex - 1] = data.myvalue;
      state.selectedStatus[data.myindex - 1] = data.mystatus;
    } else {
      state.selectedStatus[data.myindex - 1] = data.mystatus;
      // state.selectedAns[data.myindex - 1] = data.myvalue;
      state.selectedAns[data.myindex - 1] = data.myvalue;
      // state.selectedValue[data.myindex - 1] = data.myvalue;
    }
  },
  clearAns(state) {
    state.selectedAns = {};
    state.selectedStatus = [];
    state.selectedStatus2 = [];
    state.AnalyzeTypeList = [];
    state.selectedShowDetial = [];
    state.selectedValue = [];
    // state.questionTag = [];
  },
  setScore(state, data) {
    state.score = data;
  },
  setShowDetail(state, data) {
    state.showDetial = data;
  },
  setSelectedShowDetial(state, data) {
    if (state.selectedShowDetial[data.myindex] === true) {
      state.selectedShowDetial[data.myindex] = false;
    } else {
      state.selectedShowDetial[data.myindex] = true;
    }
    // state.selectedShowDetial[data.myindex] = data.mystatus;
  },
  setSelectedStatus(state, data) {
    state.selectedStatus2[data.myindex - 1] = data.mystatus;
  },
  setAnalyzeTypeList(state, data) {
    if (data.type === 'all') {
      for (let i = 0; i < state.questions.totalQuestion; i += 1) {
        state.AnalyzeTypeList[i] = data.mymethod;
      }
    } else {

      state.AnalyzeTypeList[data.myindex - 1] = data.mymethod;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
